import { TRADES } from '../../../constants/chatRooms'
import { setPageTitle } from '../../../utils/utilities'
import MessageList from '../../Messages/MessageList'
import Tooltip from '../../Utilities/Tooltip'

const TradeHistory = () => {
  setPageTitle('Trade History')

  return (
    <div className="flex h-full w-full flex-col">
      <div className="flex items-center mb-5">
        <h2 className="mr-3">Trade History</h2>
        <Tooltip>
          View trade history here. Use the icons to edit, resend, or delete
          messages.
        </Tooltip>
      </div>

      <MessageList channel={TRADES} modView />
    </div>
  )
}

export default TradeHistory
